/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientName/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from '../helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PatientName({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/PatientName"
  
}) {
let eventAppointmentPatientPersonValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.patient.person',
})
let timegridHipaaValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'hipaa',
})
let aggregateData = fromAggregate.patientName(eventAppointmentPatientPersonValueData, timegridHipaaValueData)
let timegridSlotIntervalValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_interval',
})
let eventBookingDurationValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'booking_duration',
})
let aggregateData1 = fromHelpers.isCompactView(timegridSlotIntervalValueData, eventBookingDurationValueData)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={-2}
 overflowX="hidden"
 overflowY={aggregateData1 ? "hidden" : "auto"}
 paddingTop={dtSpaceXxxs}
 whiteSpace={aggregateData1 ? "nowrap" : "inherit"}
 wordBreak={aggregateData1 ? "break-word" : "inherit"}
 textOverflow={aggregateData1 ? "ellipsis" : "inherit"}
 data="event.appointment.patient.person"
 data="timegrid.hipaa"
 aggregate="/Data/aggregate.js patientName"
 text={aggregateData}
 weight="medium"
 data="timegrid.slot_interval"
 data="event.booking_duration"
 aggregate="../helpers.js isCompactView"
/>
{children}
</React.Fragment>)
}